<template>
<section class="container">
  <scroll
        :data="dataList"
        :allLoaded="allLoaded"
        @pulldown="pullDown"
        @loadUp="loadup"
        class="scroll_box"
      >
  <!-- 停车场 -->
  <section class="parking_box">
    <section class="parking_name" @click="parkSelectFun">
      <img :src="require(`../../assets/images/icon_location_${common.theme}.png`)" />
      <span>{{parkData.parkName}}</span>
      <img v-if="parkList.length > 1" src="../../assets/images/icon_arrows_filter_normal.png" />
    </section>
    <p v-if="common.userTenantInfo && common.userTenantInfo.company" class="company">公司: {{common.userTenantInfo.company}}</p>
  </section>
  <section class="coupon_list" v-if="dataList.length>0">
      <coupon-item v-for="item in dataList" :item="item" :key="item.couponHeaderId" @cardDispatch="cardDispatch" @qrDispatch="qrDispatch"></coupon-item>
  </section>
  <!-- 无数据 -->
  <section class="no_message" v-if="loaded && dataList.length == 0">
    <p>没有停车券</p>
    <span>去购券中心看看吧~</span>
    <button @click="toBuy">去购券</button>
  </section>
  </scroll>
  <!-- 底部按钮 -->
  <section class="footer_box">
    <section class="footer_btn footer_left" @click="toRecord">派券记录</section>
    <section class="footer_btn" @click="toBuy">
      <span>购券中心</span>
      <img src="../../assets/images/img_label_buy_coupon.png">
    </section>
  </section>
  <!-- 车牌派券 -->
  <mt-popup v-model="showKeyboard" position="bottom" class="keyBox">
    <section class="card_box">
      <section class="card_top">
        <span class="top_left" @click="showKeyboard = false">取消</span>
        <span class="top_right" @click="confirmDispatch">确认派券</span>
      </section>
      <h2>输车牌派券</h2>
      <section class="cardBox" @click="showKeyboard = true">
        <span :class="['card_item',(licenseNumber.length == item-1 && showKeyboard)&&common.theme==2?'curS':'',(licenseNumber.length == item-1 && showKeyboard)&&common.theme==1?'curS_2':'']" v-for="item in 8" :key="item">
          {{licenseNumber[item-1]}}
          <img v-if="item==8" src="../../assets/images/xny.png" />
        </span>
      </section>
      <!-- 在场提示 -->
      <section class="tips" v-if="cardMessage.enterDate">
        <span></span>
        <p>入场时间: {{cardMessage.enterDate | filtersDate}} 计费时长: {{cardMessage.parkingTime|filterParkingTime}}</p>
      </section>
      <!-- 数量 -->
      <section class="num_main">
        <span class="num_title">数量</span>
        <section class="num_box">
          <span class="num_box_left" @click="reduce"></span>
          <input class="num_box_center" type="tel" @blur="blur" v-model="bindCount" @input="inputV">
          <span @click="add" class="num_box_left num_box_right"></span>
        </section>
      </section>
      <!-- 剩余未指派数量 -->
      <section class="num_modal">
        <p class="last_num">剩余未指派: {{surplusNumber}}</p>
        <p class="one_time" v-if="maxDistribut">单次最多派发{{maxDistribut}}张</p>
      </section>
    </section>
    <key-board :showTopBtn="false" :keyBoardType="keyBoardType" :numClick="numClick" :textClick="textClick" @hideModal="showKeyboard = false" @inputchange="inputchange"></key-board>
  </mt-popup>
  <!-- 二维码派券 -->
  <mt-popup v-model="showQrBoard" position="bottom" class="keyBox">
    <section class="qr_box card_box">
      <section class="card_top">
        <span class="top_left" @click="showQrBoard = false">取消</span>
        <span class="top_right" @click="getQrCode">生成二维码</span>
      </section>
      <h2>派发券数</h2>
      <section class="num_box">
        <span class="num_box_left" @click="reduce"></span>
        <input class="num_box_center" type="tel" v-model="bindCount" @blur="blur" @input="inputV">
        <span class="num_box_left num_box_right" @click="add"></span>
      </section>
      <!-- 剩余未指派数量 -->
      <section class="num_modal">
        <p class="last_num">剩余未指派: {{surplusNumber}}</p>
        <p class="one_time" v-if="maxDistribut">单次最多派发{{maxDistribut}}张</p>
      </section>
    </section>
  </mt-popup>
  <mt-popup v-model="parkSelect" position="bottom" class="park_popup">
   <mt-picker class="picker" :slots="parkDataList" @change="onValuesChange" :visible-item-count="5" :show-toolbar="true" ref="picker" >
      <div class="picker_wrap">
        <div class="picker_btn" @click="parkSelect=false">取消</div>
        <div class="picker_btn2" @click="handleConfirm">确认</div>
      </div>
    </mt-picker>
  </mt-popup>
</section>
</template>
<script>
import {mapState} from 'vuex'
import { callSpaceUp } from '../../utils/api'
import util from '../../utils/util'
import Scroll from "../../components/scroll"
import KeyBoard from '../parkingService/components/keyboard';
import CouponItem from './components/couponItemShadow'
import storage from '../../utils/storage'
export default {
  name: 'parkingCoupon',
  props: {},
  components: {
      CouponItem,
      Scroll,
      KeyBoard
  },
  filters: {
    filtersDate(value) {
      return value ? value.slice(0, 4) + '-' + value.slice(4, 6) + '-' + value.slice(6, 8) + ' ' + value.slice(8, 10) + ':' + value.slice(10, 12) + ':' + value.slice(12, 14) : '';
    },
    filterParkingTime(value) {
      return util.selvateTime(value) ? util.selvateTime(value) : '0分钟'
    },
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      dataList:[],
      parkDataList:[{
        flex: 1,
        values: [],
        className: 'slot1',
        textAlign: 'center'
      }],
      parkSelect:false,
      loaded:false,//是否调用了接口
      allLoaded:false,
      showKeyboard:false,
      showQrBoard:false,
      licenseNumber: [],
      cardMessage:{},//输入车牌获取的入场信息
      couponHeaderId:'',//选中的优惠券id
      surplusNumber:0,//选中的剩余券数量
      maxDistribut:0,//选中的最大可派发数量
      bindCount:1,//派发几张
      keyBoardType: 1, // 键盘类型
      numClick: 2, // 数字是否可点 2:不可点
      textClick: 2, // 文字是否可点2:不可点
      number:1,
      parkData:[],//停车场信息
      parkList:[],//停车场列表
      pageSize:10,
      pageNo:1,
      selectCouponType:'1',//二维码派券选中的券类型
      isconfirmDispatch:false  //防止连续点击
    }
  },
  created(){
    this.getParkName();
  },
  activated(){
    if(this.common.isChange){
      this.$store.commit('isChange', false);
      this.getParkName();
    }
  },
  methods:{
    blur(){
      setTimeout(function(){
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
      if(this.bindCount < 1){
        // util.showToast('不能低于最少派发数量')
        this.bindCount = 1
      }
    },
    // 获取停车场信息
    getParkName(){
      util.showLoading()
      let params = {
         subProjectId:this.common.marketInfo.id,
         url:'/parking/rstParkHeader/queryParkHeaderList'
      }
      callSpaceUp(params).then(res => {
        console.log(res)
        util.hideLoading()
        if(res.res.code==10000){
          this.parkList = res.body.data
          if(storage.get('parkData'+this.common.marketInfo.id)){
            this.parkData = JSON.parse(storage.get('parkData'+this.common.marketInfo.id))
          }else{
            this.parkData = res.body.data[0]
          }
          this.queryMyParkCouponOrderList()
        }else{
          util.showToast("停车场获取失败");
        }
      });
    },
    // 获取个人券中心列表
    queryMyParkCouponOrderList(){
      this.allLoaded = false;
      util.showLoading()
      let params = {
        subProjectId: this.common.marketInfo.id,
        prkHeaderId: this.parkData.id,
        phone:this.common.userInfo.phone || this.common.userInfo.account,
        pageNo:this.pageNo,
        pageSize:this.pageSize,
        url: "/parking/rstParkCoupon/queryMyParkCouponOrderList"
      }
      callSpaceUp(params).then(res =>{
        console.log(res)
        util.hideLoading()
        this.loaded = true;
        if(res.res.code === 10000 && res.body){
          if(this.pageNo == 1){
            this.dataList = res.body.data || []
          }else{
            this.dataList = this.dataList.concat(res.body.data)
          }
          if(res.body.data.length !== 10){
            this.allLoaded = true;
          }
        }else{
          util.showToast(res.res.msg)
        }
      })
    },
    onValuesChange (picker, values) {
      if (values[0] > values[1]) {
        picker.setSlotValue(1, values[0]);
      }
    },
    handleConfirm(){
      this.parkSelect = false
      var value = this.$refs.picker.getValues()[0];
      this.parkList.forEach(item=>{
        if(item.parkName == value){
          this.parkData = item;
          storage.set('parkData'+this.common.marketInfo.id,JSON.stringify(item))
        }
      })
      this.queryMyParkCouponOrderList()
    },
    parkSelectFun(){
      if(this.parkList.length <= 1){
        return;
      }
      this.parkSelect = true
      this.parkDataList[0].values = []
      this.parkList.forEach(item=>{
        this.parkDataList[0].values.push(item.parkName)
      })
    },
    // 确认派券
    confirmDispatch(){
      var that =this;
      if(!util.isLicensePlate(this.licenseNumber.join(""))){
        util.showToast('请输入正确的车牌号')
        return;
      }
      if(this.isconfirmDispatch){
         return;
      }
      util.showLoading('派券中...')
      this.isconfirmDispatch =true;
      let params = {
        couponHeaderId:this.couponHeaderId,
        phone:this.common.userInfo.phone || this.common.userInfo.account,
        plateNo:this.licenseNumber.join(""),
        bindCount:this.bindCount,
        userId: this.common.userId,
        userName:this.common.userInfo.userName,
        url: "/parking/rstParkCoupon/bindParkCoupon"
      }
      callSpaceUp(params).then(res=>{
        util.hideLoading()

        if(res.res.code === 10000){
          this.showKeyboard = false;
          util.showToast('派券成功')
          setTimeout(() => {
            that.isconfirmDispatch =false
            that.pageNo = 1;
            that.queryMyParkCouponOrderList()
          }, 2000);
        }else{
          util.showToast(res.res.msg)
        }
      })

      setTimeout(() => {
          util.hideLoading()
          that.isconfirmDispatch =false
      },5000);
    },
    // 生成二维码
    getQrCode(){
      var that =this
      if(this.isconfirmDispatch){
         return;
      }
      util.showLoading()
      this.isconfirmDispatch =true;
      let params = {
        couponHeaderId:this.couponHeaderId,
        phone:this.common.userInfo.phone || this.common.userInfo.account,
        bindCount:this.bindCount,
        userId: this.common.userId,
        userName:this.common.userInfo.userName,
        url: "/parking/rstParkCoupon/lockParkCoupon"
      }
      callSpaceUp(params).then(res=>{
        util.hideLoading()
        this.isconfirmDispatch =false
        console.log(res)
        if(res.res.code === 10000){
          this.showQrBoard = false;
          this.$store.commit("isChange",true)
          this.$router.push(`/qrcodeDispatch?scene=${res.body.data.scene}&bindCount=${this.bindCount}&couponType=${this.selectCouponType}`)
        }else{
          util.showToast(res.res.msg)
        }
      })
       setTimeout(() => {
          util.hideLoading()
          that.isconfirmDispatch =false
      },5000);
    },
    loadup(){
      if(this.allLoaded){return;}
      this.pageNo ++ ;
      this.queryMyParkCouponOrderList();
    },
    pullDown(){
      this.pageNo = 1;
      this.queryMyParkCouponOrderList()
    },
    // 点击输车牌派券
    cardDispatch(item){
      this.bindCount = 1;
      this.licenseNumber = [];
      this.cardMessage = {};
      this.keyBoardType = 1, // 键盘类型
      this.numClick = 2, // 数字是否可点 2:不可点
      this.textClick = 2, // 文字是否可点2:不可点
      this.couponHeaderId = item.couponHeaderId;
      this.maxDistribut = item.maxDistribut;
      this.surplusNumber = item.surplusNumber;
      this.showKeyboard = !this.showKeyboard
    },
    qrDispatch(item){
      console.log(item)
      this.bindCount = 1;
      this.selectCouponType = item.couponType;
      this.couponHeaderId = item.couponHeaderId;
      this.maxDistribut = item.maxDistribut;
      this.surplusNumber = item.surplusNumber;
      this.showQrBoard = !this.showQrBoard
    },
    add(){
      let max = Math.min(this.surplusNumber,this.maxDistribut);
      console.log(max)
      if(this.bindCount == max){
        util.showToast(`最多可派发${max}张`)
        return
      }
      this.bindCount = this.bindCount+1
    },
    reduce(){
      if(this.bindCount == 1){
        util.showToast('不能低于最少派发数量')
        return;
      }
      this.bindCount = this.bindCount-1
    },
    inputV(){
      let max = Math.min(this.surplusNumber,this.maxDistribut);
      // if(this.bindCount < 1){
      //   util.showToast('不能低于最少派发数量')
      //   this.bindCount = 1
      // }else
      if(this.bindCount > max){
        util.showToast(`最多可派发${max}张`)
        this.bindCount = max
      }
    },
    toRecord(){
      this.$router.push(`/dispatchRecord?prkHeaderId=${this.parkData.id}`)
    },
    toBuy(){
      this.$router.push(`/buyCoupon?prkHeaderId=${this.parkData.id}`)
    },
    inputchange(value) {
      let arr = this.licenseNumber;
      if (arr.length > 0) {
        this.numClick = 1;
      } else {
        this.numClick = 2;
      }
      if (arr.length > 5) {
        this.textClick = 1;
      } else {
        this.textClick = 2;
      }
      // 如果长度已经等于8且不是删除键,不做处理
      if (arr.length === 8 && value !== 'delete') {
        return;
      }
      // 切换键盘
      if (this.keyBoardType === 1) {
        if (value === 'delete') {
          this.hideModal();
        } else {
          this.keyBoardType = 2;
          arr.push(value);
        }
      } else {
        if (value === 'delete') {
          arr.splice(-1, 1);
          if (arr.length === 0) {
            this.keyBoardType = 1;
          }
        } else {
          arr.push(value);
        }
      }
      // 如果车牌号输了7,8位,请求查询接口,判断是否有入场信息
      if(arr.length >= 7){
        if (util.isLicensePlate(arr.join(""))) {
          this.searchCardMessage(arr.join(""))
        }
      }
    },
    searchCardMessage(plateNo){
      let params = {
        parkHeaderId: this.parkData.id,
        plateNo: plateNo,
        url: '/parking/rstParkBill/getParkFee'
      }
      callSpaceUp(params).then(res=>{
        console.log(res)
        if(res.res.code === 10000){
          this.cardMessage = res.body.data
        }
      })
    },
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
  height:100vh;
  display: flex;
  flex-direction: column;
}
.scroll_box{
  margin-bottom: 108px;
}
// 停车场
.parking_box{
  padding:32px 0 0 28px;
  .parking_name {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    height: 60px;
    background: rgba(0,0,0,0.04);
    border-radius: 30px;
    padding: 0 20px 0 12px;
    margin-bottom: 24px;
    img {
        width: 32px;
        height: 32px;
        margin-right: 8px;
    }
  }
  .company{
    font-size:24px;
    color:rgba(0,0,0,0.5);
    line-height:34px;
    margin-left:12px;
    margin-bottom: 30px;
  }
}
// 券列表
.coupon_list{
  flex:1;
}
// 底部按钮
.footer_box{
  height:108px;
  background:rgba(255,255,255,1);
  box-shadow:0px -4px 16px 0px rgba(0,0,0,0.05);
  .flex();
  position: fixed;
  bottom:0;left:0;right:0;
  z-index:2;
  .footer_btn{
    position: relative;
    flex:1;
    line-height: 108px;
    text-align: center;
    font-size:28px;
    color:rgba(51,51,51,1);
    img{
      position: absolute;
      top:4px;
      width:174px;
      height:38px;
      left:50%;
      transform: translate(-50%);
    }
  }
  .footer_left::after{
    position: absolute;
    right:0;top:34px;
    content:'';
    height:40px;
    width:2px;
    background:rgba(218,218,218,1);
  }
}
.no_message{
  margin-bottom:108px;
  margin-top:276px;
  .flex(column);
  justify-content: center;
  align-items: center;
  p{
    font-size:32px;
    color:rgba(153,153,153,1);
    line-height:44px;
    margin-bottom: 14px;
  }
  span{
    font-size:28px;
    color:rgba(201,201,201,1);
    line-height:40px;
    margin-bottom: 60px;
  }
  button{
    width:192px;
    height:68px;
    border-radius:8px;
    border:2px solid rgba(218,218,218,1);
    text-align: center;
    line-height: 68px;
    box-sizing: border-box;
    font-size:28px;
    color:rgba(51,51,51,1);
  }
}
// 车牌号
.cardBox {
    .flex();
    justify-content: center;
    margin: 60px 0;
    background: #fff;
    position:relative;
    .card_item {
        width: 72px;
        height: 84px;
        line-height: 84px;
        border-radius: 4px;
        // .border_2px(rgba(224,224,224,1));
        border: 2px solid rgba(224,224,224,1);
        text-align: center;
        margin: 0 5px;
        position: relative;
        font-size: 40px;
        // font-weight: bold;
        &:last-child {
            background: rgba(243,251,249,1);
            .border_2px(rgba(198,238,225,1));
        }
        img {
            display: block;
            width: 80px;
            height: 30px;
            position: absolute;
            top: -18px;
            left: 50%;
            transform: translate(-50%);
        }
    }
    .curS {
        .border_2px(rgba(23,64,218,1));
        &:last-child {
            .border_2px(rgba(23,64,218,1));
        }
    }
    .curS_2 {
        .border_2px(#333333);
    }
  .cardbox_item{
    width:112px;
    height:112px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing:border-box;
    border-bottom:4px solid #999;
    margin:0 20px;
    position:relative;
    font-size:60px;
    // font-weight:bold;
    color:rgba(23,64,218,1);
  }
  .line{
    &:after{
      content:'';
      position:absolute;
      width:4px;
      height:60px;
      background:rgba(23,64,218,1);
      top:50%;
      left:50%;
      transform: translate(-50%,-50%);
    }
  }
  .card_input{
    position: absolute;
    top:0;left:0;bottom:0;
    width:100%;
    z-index:2;
    opacity: 0;
  }
}
.keyBox{
  border-radius:16px 16px 0px 0px;
  overflow: hidden;
}
.card_box{
  background:rgba(255,255,255,1);
  border-radius:16px 16px 0px 0px;
  overflow:hidden;
  padding:0 28px;
  .card_top{
    .flex();
    justify-content: space-between;
    height:80px;
    align-items: center;
    .top_left{
      height:80px;
      line-height: 80px;
      font-size:28px;
      padding-right:50px;
      color:rgba(51,51,51,1);
    }
    .top_right{
      height:80px;
      line-height: 80px;
      padding-left:50px;
      font-size:28px;
      color:rgba(23,64,218,1);
    }
  }
  h2{
    font-size:36px;
    color:rgba(51,51,51,1);
    line-height:50px;
    margin-bottom:40px;
    text-align:center;
  }
  .tips{
    position:relative;
    margin-top:-40px;
    margin-bottom: 40px;
    margin-left:10px;
    p{
      display: inline-block;
      height:52px;
      background:rgba(255,242,232,1);
      border-radius:4px;
      font-size:24px;
      color:rgba(102,102,102,1);
      line-height:52px;
      padding:0 12px;
      position: relative;
      z-index:2;
    }
    span{
      display: block;
      width:24px;
      height:24px;
      background:rgba(255,242,232,1);
      transform: rotate(45deg);
      position: absolute;
      top:-8px;
      left:30px;
    }
  }
  .num_main{
    .flex();
    margin-bottom:28px;
    .num_title{
      width:116px;
      font-size:28px;
      color:rgba(51,51,51,1);
      line-height:56px;
    }
  }
  .num_box{
    .flex();
    justify-content: center;
    .num_box_left{
      position: relative;
      width:56px;
      height:56px;
      background:rgba(238,238,238,1);
      border-radius:4px;
      &:after{
        position: absolute;
        left:50%;
        top:50%;
        content:'';
        transform: translate(-50%,-50%);
        width:24px;
        height:4px;
        background:#666;
        border-radius:2px;
      }
    }
    .num_box_center{
      width:108px;
      height:56px;
      background:rgba(248,248,248,1);
      border-radius:4px;
      text-align: center;
      font-size:28px;
      color:rgba(51,51,51,1);
      margin:0 10px;
    }
    .num_box_right{
      &:before{
        position: absolute;
        left:50%;
        top:50%;
        content:'';
        transform: translate(-50%,-50%);
        width:4px;
        height:24px;
        background:#666;
        border-radius:2px;
      }
    }
  }
  .num_modal{
    .flex();
    margin-bottom: 38px;
    .last_num{
      font-size:26px;
      color:rgba(102,102,102,1);
      line-height:36px;
      margin-right:28px;
    }
    .one_time{
      font-size:26px;
      color:rgba(255,126,30,1);
      line-height:36px;
    }
  }
}
.qr_box{
  .num_box{
    margin-bottom: 28px;
    .num_box_left{
      width:88px;
      height:88px;
      border-radius:8px;
      background:transparent;
      border:2px solid rgba(234,234,234,1);
      &:after{
        width:28px;
        height:2px;
        background:rgba(51,51,51,1);
        border-radius:2px;
      }
    }
    .num_box_center{
      width:332px;
      height:88px;
      background:transparent;
      border-radius:8px;
      border:2px solid rgba(234,234,234,1);
    }
  }
  .num_modal{
    justify-content: center;
    margin-bottom: 100px;
  }
}
</style>
